import script from "./SkypeContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkypeContainer.vue?vue&type=script&lang=ts&setup=true"

import "./SkypeContainer.vue?vue&type=style&index=0&id=737852e7&lang=css"

const __exports__ = script;

export default __exports__